// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './services/firebase';

// Pages
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ClientDashboard from './pages/ClientDashboard';
import SubmitStory from './pages/SubmitStory';
import TeamQueue from './pages/TeamQueue';
import SubmissionSuccess from './pages/SubmissionSuccess';

// Loading component
const Loading = () => (
  <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl flex items-center justify-center mx-auto mb-4 animate-pulse">
        <span className="text-white text-2xl font-bold">S</span>
      </div>
      <p className="text-neutral-600">Loading...</p>
    </div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        {/* Protected Client Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/submit"
          element={
            <ProtectedRoute>
              <SubmitStory />
            </ProtectedRoute>
          }
        />
        <Route
  path="/submission-success"
  element={
    <ProtectedRoute>
      <SubmissionSuccess />
    </ProtectedRoute>
  }
/>
        {/* Protected Team Routes */}
        <Route
          path="/team/queue"
          element={
            <ProtectedRoute>
              <TeamQueue />
            </ProtectedRoute>
          }
        />

        {/* Default Redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
